import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "./AuthContext";
import { BottomNav } from "../components/BottomNav";
import { Navbar } from "../components/Navbar";

export const ProtectedRoute = (props: { installApp: Function }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="flex items-center justify-center h-screen">
        <div className="animate-spin rounded-full h-10 w-10 border-t-2 border-b-2 border-gray-900"></div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/dash/login" replace />;
  }

  return (
    <>
      <Navbar installApp={props.installApp} />
      <Outlet />
      <BottomNav />
    </>
  );
};
